export default [
  {
    path: 'users',
    name: 'users',
    component: () => import('@/views/pages/user/users-list/UsersList.vue'),
    meta: {
      pageTitle: 'Users',
      breadcrumb: [
        {
          text: 'Users',
          active: true,
        },
      ],
      resource: 'All',
    },
  },
]
